import { SiteAboutPanel } from '@jarvis/platform-ui';
import { SITE_SUPPORT_COPY } from '../../siteSupport/config';

function AssistantCoreComponents() {
  return (
    <>
      <p className="theme-preferences__hint">
        Major libraries and data sources used by this site, plus attributions for contributed datasets.
      </p>
      <div className="theme-preferences__subsection" aria-labelledby="site-about-core-major-heading">
        <h4 id="site-about-core-major-heading" className="theme-preferences__subsection-title">
          Major
        </h4>
        <dl className="theme-preferences__meta-grid theme-preferences__meta-grid--wide">
          <dt>DevExtreme</dt>
          <dd>UI components and VectorMap used across Assistant apps (including World Clock).</dd>
          <dt>React</dt>
          <dd>Client SPA runtime and component model.</dd>
          <dt>ASP.NET Core</dt>
          <dd>BFF host (API, auth, and static SPA delivery).</dd>
        </dl>
      </div>
      <div
        className="theme-preferences__subsection"
        aria-labelledby="site-about-core-contributing-heading"
      >
        <h4 id="site-about-core-contributing-heading" className="theme-preferences__subsection-title">
          Contributing / data
        </h4>
        <p className="theme-preferences__hint theme-preferences__hint--tight">
          Timezone boundaries ©{' '}
          <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer">
            OpenStreetMap
          </a>{' '}
          contributors,{' '}
          <a href="https://opendatacommons.org/licenses/odbl/" target="_blank" rel="noreferrer">
            ODbL
          </a>
          . Source:{' '}
          <a
            href="https://github.com/evansiroky/timezone-boundary-builder"
            target="_blank"
            rel="noreferrer"
          >
            timezone-boundary-builder
          </a>
          .
        </p>
      </div>
    </>
  );
}

export function SettingsAboutPage() {
  return (
    <SiteAboutPanel
      productName={SITE_SUPPORT_COPY.productName}
      coreComponents={<AssistantCoreComponents />}
    />
  );
}
